<template>
  <loading-indicator v-if="!isMealComponentLoadDone" :is-full-page="true" />
  <div v-else-if="mealComponent !== null" class="container">
    <div class="meal-component my-5">
      <div>
        <div class="text-center header-row py-2">
          <!-- eslint-disable-next-line vue/no-v-html mealComponent.name néha tartalmaz html-t -->
          <h2 class="text-center" v-html="mealComponent.name" />
        </div>
        <div class="data-row d-flex flex-wrap py-2">
          <div class="col-8" v-t="'kaloszlist_feherje'" />
          <div class="col-4">
            {{ mealComponent.data.protein }} {{ mealComponent.chartData.weight.datasets[0].unit }}
          </div>
        </div>
        <div class="data-row d-flex flex-wrap py-2">
          <div class="col-8" v-t="'kaloszlist_szenhidrat'" />
          <div class="col-4">
            {{ mealComponent.data.carbohydrate }} {{ mealComponent.chartData.weight.datasets[0].unit }}
          </div>
        </div>
        <div class="data-row d-flex flex-wrap py-2">
          <div class="col-8" v-t="'kaloszlist_zsir'" />
          <div class="col-4">
            {{ mealComponent.data.fat }} {{ mealComponent.chartData.weight.datasets[0].unit }}
          </div>
        </div>
        <div class="data-row d-flex flex-wrap py-2">
          <div class="col-8" v-t="'kaloszlist_viz'" />
          <div class="col-4">
            {{ mealComponent.data.water }} {{ mealComponent.chartData.weight.datasets[0].unit }}
          </div>
        </div>
        <div class="data-row d-flex flex-wrap py-2">
          <div class="col-8" v-t="'kaloszlist_energia'" />
          <div class="col-4">
            {{ mealComponent.data.calorie }} {{ mealComponent.chartData.weight.datasets[0].unit }}
          </div>
        </div>
        <div v-if="mealComponent.data.isBodyBuilder" class="data-row d-flex flex-wrap py-2">
          <div class="col-8">
            <i class="fas fa-child"></i>
            <span v-t="'kaloszlist_testepito'" />
          </div>
          <div class="col-4" />
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-around chart-row">
        <pie-chart-block
          :chart-title="$t('kaloszlist_graf_sulyeloszlas')"
          :chart-data="mealComponent.chartData.weight"
        />
        <pie-chart-block
          :chart-title="$t('kaloszlist_graf_energiaeloszlas')"
          :chart-data="mealComponent.chartData.energy"
        />
      </div>
    </div>
    <candy-bar
      v-if="mealComponent.productListContainsComponent.length !== 0"
      :title="$t('kaloszlist_termekek')"
      :product-list="mealComponent.productListContainsComponent"
      class="my-3"
    />
  </div>
  <div
    v-else
    v-t="'nincs_megjelenitheto_tartalom'"
    class="text-center my-5 container"
  />
</template>

<script>
import Axios from 'axios'

export default {
  name: 'mealComponent',
  components: {
    'loading-indicator': () => import(/* webpackChunkName: "LoadingIndicator" */ '../../components/LoadingIndicator/LoadingIndicator.vue'),
    'candy-bar': () => import(/* webpackChunkName: "CandyBar" */ '../../components/CandyBar/CandyBar.vue'),
    'pie-chart-block': () => import(/* webpackChunkName: "pieChartBlock" */ '../../components/pieChart/pieChartBlock.vue'),
  },
  data() {
    return {
      /**
       * meal component data betöltődött-e
       *
       * @type Boolean
       */
      isMealComponentLoadDone: false,
      /**
       * meal component adatok
       *
       * @type {{
       *   name: String,
       *   metaTitle: String,
       *   productListContainsComponent: Array,
       *   data: {
       *     protein: Number,
       *     carbohydrate: Number,
       *     fat: Number,
       *     water: Number,
       *     calorie: Number,
       *     isBodyBuilder: Boolean,
       *   },
       *   chartData: {
       *     weight: {
       *      datasets: [{
       *         backgroundColor: [
       *             String,
       *         ],
       *         data: [
       *            Number,
       *         ],
       *         labels: [
       *            String,
       *         ],
       *         percent: [
       *            Number,
       *         ],
       *         unit: String,
       *      },],
       *      labels: [],
       *     },
       *     energy: {
       *      datasets: [{
       *         backgroundColor: [
       *             String,
       *         ],
       *         data: [
       *            Number,
       *         ],
       *         labels: [
       *            String,
       *         ],
       *         percent: [
       *            Number,
       *         ],
       *         unit: String,
       *      },],
       *      labels: [],
       *     },
       *   }
       * }|null}
       */
      mealComponent: null,
    }
  },
  created() {
    this.loadMealComponentData()
  },
  methods: {
    /**
     * meal component adatok betöltése
     */
    loadMealComponentData() {
      Axios.get('/MealPlanner/api/getMealComponentData', {
        params: {
          id: this.$route.params.id,
        },
      })
        .then(({ data }) => {
          this.mealComponent = data
          document.title = this.mealComponent.metaTitle
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.isMealComponentLoadDone = true
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.meal-component {
  border: 1px solid #000;

  .data-row {
    border-bottom: 1px solid #000;
  }

  .header-row {
    border-bottom: 4px solid #000;
  }

  .chart-row {
    border-top: 4px solid #000;
  }
}
</style>
